import posthog from "posthog-js";
import { isImpersonating } from "@/services/auth";
import { sanitizeTrackingProps } from "@/lib/tracking/sanitize-url";
import { CREDENTIAL_LINK_SELECTOR, maskCredentialText } from "@/lib/tracking/credentials";
import { getTenant } from "@/helpers/tenant";
import { writeSharedHostDistinctId } from "@/lib/posthogIdentityCookie";

export const isLocalDev =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".localhost") ||
  window.location.hostname === "127.0.0.1";

if (!isLocalDev && !isImpersonating()) {
  posthog.init("phc_mjbHNZZQIpsRJIEhaAQbPfgACMa3f8RF66HEKgHd6jF", {
    api_host: "https://n.getaltimate.com",
    persistence: "memory",
    autocapture: {
      dom_event_allowlist: ["click", "submit"],
      element_allowlist: ["button", "a", "form", "input", "select"],
    },
    capture_pageview: "history_change",
    capture_pageleave: true,
    // Autocapture + $pageview/$pageleave attach $current_url / $pathname /
    // $referrer automatically. On /login/<token> etc. those carry a replayable
    // verification token, so scrub every URL/path property before send (AI-8118).
    sanitize_properties: properties => sanitizeTrackingProps(properties),
    // Recordings keep page text and attributes as rendered, and some pages show
    // the user's API key. Send every text node through the credential mask, and
    // leave out links that carry a credential (AI-10227).
    session_recording: {
      maskTextSelector: "*",
      maskTextFn: maskCredentialText,
      blockSelector: CREDENTIAL_LINK_SELECTOR,
      // Never network headers or bodies: they carry the Bearer token and
      // one-time login tickets. An explicit `false` here overrides the
      // project's remote network-capture setting.
      recordHeaders: false,
      recordBody: false,
    },
  });
  // On the tenantless shared host (sign-up, CLI hand-off) hand this load's
  // anonymous id to the tenant host, whose post-login identify aliases it.
  if (getTenant() === "") {
    try {
      writeSharedHostDistinctId(window.location.hostname, posthog.get_distinct_id());
    } catch (error) {
      console.warn("Failed to write the shared-host PostHog id cookie:", error);
    }
  }
}

export default posthog;
